export const HR_APPLY_PERSONAL_INFO = "batmaid-hr/apply-personal-info";
export const HR_APPLY_EXPERIENCE_INFO = "batmaid-hr/{country}-apply-experience";
export const HR_APPLY_AUTH_TOKEN = "batmaid-hr/apply-auth-token";
export const MULTIPART_FORM_DATA = "multipart/form-data";
